<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/courses']" [queryParams]="{tab:tab}"><img
            src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userCouresLatest pb-2">
                    <div class="imgUploadWrap">
                        <span class="userCouresImage" style="background: url(assets/images/demo.png);"></span>
                        <!-- <div class="imgUpload">
                            <input type="file" />
                            <span>CHANGE PICTURE</span>
                        </div> -->
                    </div>
                    <div class="userCouresContent" *ngIf="viewUsersDetail">
                        <h3>{{viewUsersDetail.course_name}}</h3>
                        <p>
                            <span *ngIf="viewUsersDetail.module_count <= 1">{{viewUsersDetail?.module_count}}
                                Module</span>
                            <span *ngIf="viewUsersDetail.module_count > 1">{{viewUsersDetail?.module_count}}
                                Modules</span>
                            <span *ngIf="viewUsersDetail.submodule_count <= 1">{{viewUsersDetail.submodule_count}} Sub
                                Module</span>
                            <span *ngIf="viewUsersDetail.submodule_count > 1">{{viewUsersDetail.submodule_count}} Sub
                                Modules</span>
                            <span *ngIf="viewUsersDetail.assessment_count <= 1">{{viewUsersDetail.assessment_count}}
                                Assessment</span>
                            <span *ngIf="viewUsersDetail.assessment_count > 1">{{viewUsersDetail.assessment_count}}
                                Assessments</span>
                        </p>
                        <p>
                            <span>Created by: {{viewUsersDetail.created_by}} on {{viewUsersDetail.created_dttm}}</span>
                        </p>
                        <p>
                            <span>End Date: {{viewUsersDetail.end_date}}</span>
                            <a href="javascript:void(0);" class="btn-link">EXTEND</a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="courseTabs" *ngIf="viewUsersDetail">
                    <p>{{viewUsersDetail.course_desc}}</p>
                    <ul class="customTab">
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_view_courses']"
                                [queryParams]="{courseId:courseId,tab:tab}">VIEW COURSES</a> </li>
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_view_user']"
                                [queryParams]="{courseId:courseId ,tab:tab}" class="active">VIEW USERS</a> </li>
                        <li *ngIf="viewUsersDetail.is_active==1"><a href="javascript:void(0);"
                                [routerLink]="['/courses_assign_users']" [queryParams]="{courseId:courseId ,tab:tab}">ASSIGN
                                USERS</a> </li>
                        <li><a href="javascript:void(0);" (click)="open(duplicate)">DUPLICATE</a> </li>
                        <li class="deactiveTab" *ngIf="viewUsersDetail.is_active==1"><a href="javascript:void(0);"
                                (click)="open(deactivate)">DEACTIVATE</a> </li>
                        <li class="deactiveTab" *ngIf="viewUsersDetail.is_active==0"><a href="javascript:void(0);"
                                (click)="open(activate)">ACTIVATE</a> </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="numberOfUsers" *ngIf="viewUsersDetail">
        <ul>
            <li>
                <div class="showUsers">
                    <h3>{{viewUsersDetail.total_users}} total Users</h3>
                </div>
            </li>
            <li>
                <div class="showUsers green">
                    <b><i></i>{{viewUsersDetail.course_completed}}</b>
                    <span>Course Completed</span>
                </div>
            </li>
            <li>
                <div class="showUsers bluecolor">
                    <b><i></i>{{viewUsersDetail.course_started}}</b>
                    <span>Course Started</span>
                </div>
            </li>
            <li>
                <div class="showUsers red">
                    <b><i></i>{{viewUsersDetail.course_not_started}}</b>
                    <span>Course Not Started</span>
                </div>
            </li>
        </ul>
    </div>
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
                <h2>Assign Courses</h2>
                <p>Select 1 or more courses from the list to assign to this user. </p>
            </div>
            <div class="col-12 col-md-4">
                <div class="filterWrap">
                    <div class="searchWrap mr-0">
                        <input type="text" placeholder="Search Users" (keyup)="search($event)">
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="tableWrap">
        <table matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th>
                        <div mat-sort-header="first_name"><b></b> User Name</div>
                    </th>
                    <th>Status</th>
                    <th>% Completed</th>
                    <th>Time<br />Spent</th>
                    <th>Modules<br />Completed</th>
                    <th>Assessments<br />Passed</th>
                    <th>
                        <div class="reset_requestTh">Assessment<br />Reset Request <b><img
                                    src="assets/images/admin/frame_red.png" /></b></div>
                    </th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody *ngIf="viewUsersDetail">
                <tr *ngFor="let values of viewUsersDetail.userlist;let i = index">
                    <td>
                        <div class="courseTdWrap">
                            <!-- <a href="javascript:void(0);">{{values.first_name}} {{values.last_name}}</a><br> -->
                            <span>{{values.first_name}} {{values.last_name}}</span><br>
                            <b>{{values.email}}</b><br>
                            <b>Assigned on {{values.created_dttm | date:'d MMM, y'}}</b>
                        </div>
                    </td>
                    <td>
                        <span *ngIf="values.status == 1" class="statusTd red">Not Started</span>
                        <span *ngIf="values.status == 2" class="ongoing">ongoing</span>
                        <span *ngIf="values.status == 3 " class="red">Completed</span>
                        <span class="d-block">Started on {{values.course_start_dttm | date:'d MMM, y'}}</span>
                        <span class="d-block">Last viewed on {{values.last_login | date:'d MMM,
                            y'}}</span>
                    </td>
                    <td><b class="blue">{{values.percent_complete==null ? '0':values.percent_complete}}%</b></td>
                    <td>{{ secondsToHms(values.total_time_spent)}}</td>
                    <td>{{values.no_of_modules_completed}}</td>
                    <td>{{values.no_of_assessments_passed}}</td>
                    <td>
                        <span
                            *ngIf="!values.assessment_id || (values.assessment_id && values.request_status !=1)">N/A</span>
                        <div class="moduleWrap" *ngIf="values.assessment_id && values.request_status ==1">
                            <p *ngIf="values.module_name && values.submodule_name">Module 1 | SUbmodule 3</p>
                            <p *ngIf="values.module_name && !values.submodule_name">Module 1</p>
                            <div class="moduleChoues">
                                <a href="javascript:void(0);" class="moduleList mr-3"
                                    (click)="openAccept(AcceptContent, values)">
                                    <i><img src="assets/images/admin/done.png" /></i>Accept
                                </a>
                                <a href="javascript:void(0);" class="moduleList"
                                    (click)="openReject(RejectContent, values)">
                                    <i><img src="assets/images/admin/close_big.png" /></i>Reject
                                </a>
                            </div>
                            <div class="moduleChoues">
                              
                                <a href="javascript:void(0);" class="btn-link" *ngIf="values.req_attempt"
                                    [routerLink]="['/reset_request']"
                                    [queryParams]="{courseId:values.user_course_id,userId:values.user_id,type:'course'}">View
                                    {{values.req_attempt}} Attempt request</a>
                            </div>
                        </div>
                    </td>
                    <td>
                        <ul class="userActionBtn">
                            <li><a href="javascript:void(0);" (click)="opens(deassign,values.user_id)"
                                    class="btn-link">DEASSIGN</a></li>
                        </ul>
                    </td>
                </tr>


            </tbody>
        </table>
    </div>
</div>
<ng-template #deassign let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Deassign User</h6>
                <p class="size18">Are you sure you want to deassign this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="DeAssignUser(userID)">Yes,
                    DeAssign</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate course</h6>
                <p class="size18">Are you sure you want to deactivate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(0)">Yes,
                    DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate course</h6>
                <p class="size18">Are you sure you want to activate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(1)">Yes,
                    Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate course</h6>
                <p class="size18">Are you sure you want to duplicate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="duplicateCourse()">Yes,
                    Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #AcceptContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click');viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Accept Reset Request</h6>
            <p>You have approved the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2"
                (click)="modal.close('Close click');viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span>Close</span>
            </a>
        </div>
    </div>
</ng-template>

<ng-template #RejectContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click');viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Reject Reset Request</h6>

            <!-- <form [formGroup]="rejectForm">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Remark</mat-label>
                        <input matInput formControlName="txtRemark" [ngClass]="{ 'is-invalid': submitted && f.txtRemark.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.txtRemark.errors">
                        <span *ngIf="f.txtRemark.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                </div>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')"> <span>Close</span>
                </a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="onSubmit(rejectForm.value)">Submit</a>
              </form> -->
            <p>You have rejected the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2"
                (click)="modal.close('Close click');viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span>Close</span>
            </a>

        </div>
    </div>
</ng-template>